import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import {
  checkSecureLink,
  getSecureLinkPageContent,
} from "../../api/services/secureData";
import { IError } from "../../types/common";

export const checkSecureLinkThunk = createAsyncThunk<string, string, IError>(
  "secureData/checkSecureLink",
  async (code, { rejectWithValue }) => {
    try {
      const { data } = await checkSecureLink(code);
      if (data?.data) {
        return data.data;
      }
      if (!data?.isSuccess) {
        return "Data is not available";
      }
      return "";
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const getSecureLinkPageContentThunk = createAsyncThunk<
  any,
  string,
  IError
>("secureData/getSecureLinkPageContent", async (code, { rejectWithValue }) => {
  try {
    const { data } = await getSecureLinkPageContent(code);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});
